export const legacyPortfolioPagesRoute = {
	name: 'legacy-portfolio-pages',
	path: '/secure/PortfolioPlan(\\w+).jspa',
};
